import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { COMMON_CONSTANTS } from '../../../common/core/common.constants';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { UtilsService } from 'src/app/services/utils.service';
import { MsisdnPipe } from '../../../shared/pipes/msisdn.pipe';

@Component({
  selector: 'app-changeservices-confirmation',
  templateUrl: './changeservices-confirmation.component.html',
  styleUrls: ['./changeservices-confirmation.component.scss'],
  providers: [MsisdnPipe]
})
export class ChangeservicesConfirmationComponent implements OnInit {
  public authoringContentData: any;
  public euiTokenData: any;
  public msisdn: string;
  public email: string;
  public orderId: string;
  public isEndUser: boolean;
  public nextBillingDate: string;
  isApprovalRequired: any;
  approvalActivitiesList: any;
  constructor(private _router: Router,
    private _cacheSvc: HttpCacheService, private _helperUtilSvc: UtilsService) { }

  ngOnInit() {
    this.isEndUser = this._helperUtilSvc.IsEndUser();
    this.msisdn = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.CHANGE_SERVICE_MSISDN));
    this.orderId = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.ORDER_ID));
    this.euiTokenData= JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA));
    this.email = !isNullOrUndefined(this.euiTokenData) ? this.euiTokenData.logonId: '';
    this.authoringContentData = JSON.parse(sessionStorage.getItem(COMMON_CONSTANTS.CONTENT));
    this.nextBillingDate = this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.CHANGESERVICEDATE);
    this.approvalActivitiesList = JSON.parse(this._cacheSvc.getFromSessionStorage('approvalFlags'));
    if (!isNullOrUndefined(this.approvalActivitiesList)) {
      for (const element of this.approvalActivitiesList) {
        if (!isNullOrUndefined(element) && element.FlagName === COMMON_CONSTANTS.IS_CHANGE_SERVICE_APPROVAL) {
          this.isApprovalRequired = element.FlagValue;
        }
      }
    }

  }

  goToManageLines() {
    if(this.isEndUser){
      this._router.navigate(['/apps/tfb_acctmgmt/account-management/line-details']);
    }else{
      this._router.navigate(['/apps/tfb_acctmgmt/account-management/lines']);
    }
  }

}
